import React from 'react';
import ProductCard from './components/ProductCard';

import auriculars from './assets/auriculars.jpg';
import smartwatch from './assets/smartwatch.jpg';
import altaveu from './assets/altaveu.jpg';
import camera from './assets/camera.jpg';
import portatil from './assets/portatil.jpg';

export default function App() {
  const products = [
    {
      name: 'Auriculars Inalàmbrics Pro',
      description:
        'Cancel·lació de soroll avançada, 30 hores de bateria i so d’alta fidelitat.',
      image: auriculars,
      price: '99,99 €',
      oldPrice: '149,99 €',
      soldOut: false,
    },
    {
      name: 'Smartwatch FitLife',
      description:
        'Pantalla AMOLED de 1,8", seguiment esportiu i notificacions intel·ligents.',
      image: smartwatch,
      price: '129,99 €',
      oldPrice: '179,99 €',
      soldOut: false,
    },
    {
      name: 'Altaveu Bluetooth MiniBoom',
      description:
        'So 360º, resistent a l’aigua IPX7 i fins a 12 hores d’autonomia.',
      image: altaveu,
      price: '49,99 €',
      oldPrice: '69,99 €',
      soldOut: true,
    },
    {
      name: 'Càmera Compacta ZoomX',
      description:
        'Sensor 4K, estabilització òptica i connectivitat Wi-Fi integrada.',
      image: camera,
      price: '299,99 €',
      oldPrice: '399,99 €',
      soldOut: false,
    },
    {
      name: 'Portàtil Ultralight AirNote',
      description:
        'Pes lleuger, processador i7, 16GB RAM i pantalla 2K per a estudiants exigents.',
      image: portatil,
      price: '899,99 €',
      oldPrice: '1099,99 €',
      soldOut: false,
    },
  ];

  return (
    <div
      style={{
        padding: 20,
        background: 'linear-gradient(180deg, #f4f6ff 0%, #eaf0ff 100%)',
        minHeight: '100vh',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginBottom: 10,
          color: '#003366',
          fontFamily: 'Segoe UI, sans-serif',
        }}
      >
        Projecte R6 – Productes destacats
      </h1>

      <p
        style={{
          textAlign: 'center',
          fontStyle: 'italic',
          color: '#666',
          marginBottom: 40,
        }}
      >
        Manuel Marcano
      </p>

      {products.map((product, index) => (
        <ProductCard key={index} {...product} />
      ))}
    </div>
  );
}
